module.exports = __webpack_public_path__ + "dac8b8e4ccff679da5a2a2c8414160aa.svg";